import { ActionType } from 'typesafe-actions'
import * as actions from './actions'
export type DemographicsActions = ActionType<typeof actions>
export { demographicsReducer } from './reducer'
export { Demographics } from './container'

// export as default for lazy loading
export { Demographics as default } from './container'
